import { filterNames } from 'src/universal/utils/vacRouterPathHelper';
import { DEFAULT_FILTER } from 'src/universal/redux/cardsFilter';
import { isBrowser } from 'acq-utils/lib/misc';

export const scrollToElement = element => {
  const diff = element.offsetTop - (window.scrollY || window.pageYOffset);
  // 61px accounts for the height of the subnav including border
  const offsetDetection = 61;
  // added for eliminating the gap between subNav and filter box (due to recent filter struct change)
  const offsetAction = offsetDetection + 1;

  if (diff > 0 - offsetDetection) {
    // US5261938: doing nothing as specified. Keeping next line for now for future reference.
    // window.scrollBy(0, diff + offsetAction);
  } else if (diff < 0 - offsetDetection) {
    window.scrollBy({ left: 0, top: diff + offsetAction, behavior: 'smooth' });
  }
};

const updateFilterPartOnUrl = (url, filterNew) => {
  const vacPath = 'business-credit-cards';
  const defaultResult = {
    resultUrl: url,
    needUpdate: false
  };

  if (
    typeof url !== 'string' ||
    url.indexOf(`/${vacPath}`) <= -1 ||
    typeof filterNew !== 'string' ||
    filterNames.indexOf(filterNew) <= -1
  ) {
    return defaultResult;
  }

  const cardListVal = (filterNames || [])
    .reduce((acc, curr) => {
      acc.push(`\\/${curr}`);
      return acc;
    }, [])
    .join('|');

  const regexObj = new RegExp(`(${cardListVal})(\\?|\\/|$)`);
  const regexResult = regexObj.exec(url);
  let toBeReplaced;
  let replaceVal;

  if (Array.isArray(regexResult) && regexResult.length > 0) {
    toBeReplaced = regexResult[0];

    if (toBeReplaced.endsWith('/') || toBeReplaced.endsWith('?')) {
      toBeReplaced = toBeReplaced.slice(0, -1);
    }

    if (filterNew === DEFAULT_FILTER) {
      replaceVal = '';
    } else {
      replaceVal = `/${filterNew}`;
    }

    if (toBeReplaced === replaceVal) {
      return defaultResult;
    }
  } else {
    toBeReplaced = `/${vacPath}`;
    replaceVal = `${toBeReplaced}/${filterNew}`;
  }

  return {
    resultUrl: url.replace(toBeReplaced, replaceVal),
    needUpdate: true
  };
};

export const updateFilterOnWindowHistory = filter => {
  if (!isBrowser()) {
    return;
  }

  const searchStr = location.search;
  const updateResult = updateFilterPartOnUrl(location.pathname, filter);

  if (updateResult.needUpdate) {
    window.history.replaceState({}, '', `${updateResult.resultUrl}${searchStr}`);
  }
};
